import React from 'react';
import styled, { keyframes } from 'styled-components';

const scale = keyframes`
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  } 
`;

const stroke = keyframes`
    100% {
        stroke-dashoffset: 0;
    }
`;

const SVG = styled.svg`
  stroke-width: 5;
  stroke: #000000;
  animation: ${scale} 0.1s ease-in-out 0.9s both;
`;

const PATH = styled.path`
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: ${stroke} 0.1s cubic-bezier(0.65, 0, 0.45, 1) 0.2s forwards;
`;

const PropertyPalCheck = () => {
  return (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <PATH fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </SVG>
  );
};

export default PropertyPalCheck;
